
import './CSS/caracteresG10.scss';
//import schemaG0Haut from './Assets/table_caractère_g0-haut.svg';
//import schemaG0Bas from './Assets/table_caractère_g0-bas.svg';
import schemaG0HautPng from './Assets/table_caractère_g0-haut.png';
import schemaG0BasPng from './Assets/table_caractère_g10- bas.png';


export default function CaracteresG10()
{
    return (
        <div className='PageG10'>
            <div id='titre'>
                <h1>Jeu de caractères G10</h1>
            </div>
            <div id ="partie_haute">
                <img className="shemaG0scv" src={schemaG0HautPng} alt="table G0" />
            </div>
            <div id="partie_basse">
                <img  className="shemaG0scv" src={schemaG0BasPng} alt="table G0" />
            </div>
        </div>
    )
}